var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "220.019px",
    height: "297.64px",
    viewBox: "0 0 220.019 297.64",
    enableBackground: "new 0 0 220.019 297.64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9C6C3",
    points: "63.071,294.578 3.591,163.606 7.729,159.331 165.328,196.915 216.36,281.932 213.392,284.602  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E5DC",
    points: "177.722,200.083 216.262,106.839 62.765,2 7.729,159.331 67.293,291.468 216.36,281.932  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9B9D9D",
    points: "172.007,203.572 191.57,246.273 58.092,235.036 29.691,170.272  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#54B3E5",
    points: "210.697,110.24 174.199,194.992 19.308,152.767 67.442,15.002  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.bec3839ab38850fdfb27a45b606948d2.svg";
export { ForwardRef as ReactComponent };